import glosarioService from "../services/glosario";
import { GeneralContext } from '../context/GeneralContext';
import { useTranslation } from 'react-i18next';
import { useContext, useEffect, useState } from "react";
import {elegirIdioma, useTools} from "./useTools"
export const useGlosario = () => {

    const { user } = useContext(GeneralContext);
    const { i18n } = useTranslation();
    const {elegirIdioma} = useTools();

    const [listaTerminos, setListaTerminos] = useState();

    useEffect(() => {
        glosarioService.getAll(user && user.language ? user.language : elegirIdioma(i18n.language)).then(data => {
            setListaTerminos(data)
        });
    }, [user]);

    return {listaTerminos};

}